import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SwisslifeLocationService } from '@app/services/swisslife-location.service';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
  selector: 'spouse-info-form',
  templateUrl: './spouse-info-form.component.html',
  styleUrls: ['./spouse-info-form.component.scss'],
  standalone: false,
})
export class SpouseInfoFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  sessionConsultant: boolean;
  isSwisslifeProduct: boolean = false;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private swisslifeLocation: SwisslifeLocationService,
    protected injector: Injector,
  ) {
    super(formConstructor, injector);
  }

  ngOnInit() {
    this.isSwisslifeProduct = this.swisslifeLocation.hasSwisslifeProduct(
      this.subscriptionFacade.getPledge(),
    );
    this.sessionConsultant =
      !!this.subscriptionFacade?.getPledge() &&
      !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    this.subscriptionFacade.initForm(this, {
      sessionConsultant: this.sessionConsultant,
    });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
